import * as React from 'react';
import { Container } from 'flux/utils';

import Badge from 'components/Badge';
import Link from 'components/Link';
import Image from 'components/Image';
import Text from 'components/Text';
import { AvatarImages } from 'constants/AvatarConstants';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

import './styles/NavigationListOrganizationItemDeprecated.scss';

type Props = {
  organization: NavigationList_me_navigationSections_items;
};

type State = {
  unreadCount: number;
};

class NavigationListOrganizationItem extends React.Component<Props, State> {
  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState(state: State, props: Props) {
    const { organization } = props;
    if (organization.__typename !== 'Organization') {
      return { unreadCount: 0 };
    }
    return {
      unreadCount: UnreadStore.getUnreadCount(organization.uuid),
    };
  }

  hasUnreads() {
    return this.state.unreadCount > 0;
  }

  renderBadge() {
    return (
      this.hasUnreads() && (
        <Badge
          className="NavigationListDeprecatedGroupItem-badge"
          count={this.state.unreadCount}
          color="lava"
          size="large"
          shape="square"
        />
      )
    );
  }

  render() {
    const { organization } = this.props;
    if (organization.__typename !== 'Organization') {
      console.warn(organization);
      console.error(
        'NavigationListOrganizationItem - tried to render with an item that was not an Organization'
      );
      return null;
    }

    const { id } = organization;
    if (!id) {
      console.debug(this.props);
      console.error('NavigationListOrganizationItem - organization without id');
      return null;
    }

    return (
      <li className="NavigationListDeprecatedOrganizationItem">
        <Link
          color="inherit"
          activeClassName="active"
          to={`/organizations/${id}`}
          className="NavigationListDeprecatedOrganizationItem-link">
          <div className="NavigationListDeprecatedOrganizationItem-container">
            <Image
              width={24}
              className="NavigationListDeprecatedOrganizationItem-avatar"
              src={AvatarImages.ORG_AVATAR}
            />
            <Text
              className="NavigationListDeprecatedOrganizationItem-name"
              truncate
              weight={this.hasUnreads() ? 'semibold' : 'normal'}>
              {organization.displayName}
            </Text>
            {this.renderBadge()}
          </div>
        </Link>
      </li>
    );
  }
}

export { NavigationListOrganizationItem };
export default Container.create(NavigationListOrganizationItem, {
  withProps: true,
  pure: false,
});
